<div class="w-100 h-100">
  <app-vst-canvas-content [options]="options" [canvasItems]="canvasItems"></app-vst-canvas-content>

  <app-vst-canvas-item-carousel></app-vst-canvas-item-carousel>
</div>